<template>
  <div class="container-fluid">
    <div class="row form-page-spacing">
      <div class="col s12">
        <div class="row">
          <b-form-group class="no-padding" style="margin-top: 11.25px">
            <p-button class="blue-color-background" :variant="'link'" :action="reset" :text="$t('reset')" />
            <p-button class="blue-color-background" :variant="'link'" :action="saveForm" :text="$t('save')" />
          </b-form-group>
        </div>
        <div class="row">
          <b-form-group>
            <label>
              <input v-model="trigger.shuntCurrentActive" type="checkbox" @change="$emit('update-trigger', 'shuntCurrentActive',  $event.target.checked)"/>
              <span>Check shunt current</span>
            </label>
          </b-form-group>

          <b-form-group>
            <label>
              <input v-model="trigger.minShuntTimeActive" type="checkbox" @change="$emit('update-trigger', 'minShuntTimeActive',  $event.target.checked)"/>
              <span>Check minimum shunt length</span>
            </label>
          </b-form-group>

          <b-form-group>
            <label>
              <input v-model="trigger.maxShuntTimeActive" type="checkbox" @change="$emit('update-trigger', 'maxShuntTimeActive',  $event.target.checked)"/>
              <span>Check maximum shunt length</span>
            </label>
          </b-form-group>

          <b-form-group label="Warning threshold (mA)" label-for="threshold-warning">
            <b-form-input :disabled="!trigger.shuntCurrentActive" type="number" id="threshold-warning" :state="false" lazy-formatter :formatter="toNumber" min="0" @input.native="input" :value="trigger.warningThreshold" @change="$emit('update-trigger', 'warningThreshold',  parseFloat($event))" />
          </b-form-group>

          <b-form-group label="Alarm threshold (mA)" label-for="threshold-alarm" :class="{'inputError': alarmThresholdTooLow}">
            <b-form-input :disabled="!trigger.shuntCurrentActive" type="number" id="threshold-alarm" lazy-formatter :formatter="toNumber" :min="(trigger.warningThreshold + 1)" @input.native="input" :value="trigger.alarmThreshold" @change="$emit('update-trigger', 'alarmThreshold',  parseFloat($event))" />
            <b-form-text v-if="alarmThresholdTooLow">Alarm threshold must be greater than the warning threshold</b-form-text>
          </b-form-group>

          <b-form-group label="Shunt threshold (mA)" label-for="threshold-shunt">
            <b-form-input :disabled="!trigger.shuntCurrentActive" type="number" id="threshold-shunt" lazy-formatter :formatter="toNumber" min="0" @input.native="input" :value="trigger.shuntThreshold" @change="$emit('update-trigger', 'shuntThreshold',  parseFloat($event))" />
          </b-form-group>

          <b-form-group label="Minimum shunt length (s)" label-for="min-shunt-length">
            <b-form-input :disabled="!trigger.minShuntTimeActive" type="number" id="min-shunt-length" lazy-formatter :formatter="toNumber" min="0" @input.native="input" :value="trigger.minShuntTime" @change="$emit('update-trigger', 'minShuntTime',  parseFloat($event))" />
          </b-form-group>

          <b-form-group label="Maximum shunt length (s)" label-for="max-shunt-length">
            <b-form-input :disabled="!trigger.maxShuntTimeActive" type="number" id="max-shunt-length" lazy-formatter :formatter="toNumber" min="0" @input.native="input" :value="trigger.maxShuntTime" @change="$emit('update-trigger', 'maxShuntTime',  parseFloat($event))" />
          </b-form-group>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import POSSButton from '@/components/POSSButton'

export default {
  components: {
    'p-button': POSSButton
  },
  name: 'settingsForm',
  props: {
    save: { type: Function, required: true },
    reset: { type: Function, required: true },
    setting: { type: Object, required: true }
  },
  data: function () {
    return {
      trigger: { ...this.setting },
      alarmThresholdTooLow: false
    }
  },
  created () {
    this.prevTimeout = 0
  },
  methods: {
    toNumber (val) {
      return val * 1
    },
    input (e) {
      if (this.prevTimeout) { clearTimeout(this.prevTimeout) }
      this.prevTimeout = setTimeout(function () {
        e.target.dispatchEvent(new Event('change'))
      }, 750)
    },
    saveForm () {
      if (this.trigger.alarmThreshold <= this.trigger.warningThreshold && this.trigger.warningThreshold !== 0 && this.trigger.alarmThreshold !== 0) {
        this.alarmThresholdTooLow = true
        throw new Error('Alarm threshold below warning threshold')
      }

      this.alarmThresholdTooLow = false

      this.save()
    }
  },
  watch: {
    setting: {
      deep: true,
      handler (val) {
        this.trigger = { ...val }
      }
    }
  }
}
</script>
<style scoped>
  button[type=button].btn {
    text-transform: capitalize;
  }

  fieldset.form-group { border: none; }

  .form-page-spacing {
    margin-right: 11.25px;
    margin-left: 11.25px;
  }

  .inputError {
    color: red;
  }
  .inputError >>> input {
    color: red;
    border-color: red !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/axleshunt/AlarmSettings/_settingsForm.vue